{
  "info": "信息",
  "negative": "错误",
  "notice": "警告",
  "positive": "成功"
}
